import React from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import EP1 from "../../assets/images/EP1.jpg";
import EP2 from "../../assets/images/EP2.jpg";
import EP3 from "../../assets/images/EP3.jpg";
import EP4 from "../../assets/images/EP4.jpg";
import EP5 from "../../assets/images/EP5.jpg";
import EP6 from "../../assets/images/EP6.jpg";
import EP7 from "../../assets/images/EP7.jpg";
import styles from "./Explore.module.scss";
import axios from "../../components/Hooks/axios";

const ExploreYourWorld = ({ posts }) => {
	const navigate = useNavigate();
	const [isMobile, setIsMobile] = useState(window.innerWidth < 427);
	const [showSearch, setShowSearch] = useState(false);
	const [Travel, setTravel] = useState(false);
	const [Funny, setFunny] = useState(false);
	const [Photography, setPhotography] = useState(false);
	const [News, setNews] = useState(false);
	const [Pets, setPets] = useState(false);
	const [RoadTrip, setRoadTrip] = useState(false);





	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 427);
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);
	return (
		<>
			<div className={styles.recommendedContainer}>
				{isMobile ? null : <p>Recommend For you</p>}
				{isMobile ? (
					<div className={styles.TagContainer}>
						<div className={styles.btnContainer}>
							<button
								type="button"
								style={{ background: Travel ? "#3A0DBB" : "", color: Travel ? "#fff" : "" }}
								onClick={() => setTravel(!Travel)}>
								Travel
							</button>
							<button
								type="button"
								style={{ background: Funny ? "#3A0DBB" : "", color: Funny ? "#fff" : "" }}
								onClick={() => setFunny(!Funny)}>
								Funny
							</button>
							<button
								type="button"
								style={{ background: Photography ? "#3A0DBB" : "", color: Photography ? "#fff" : "" }}
								onClick={() => setPhotography(!Photography)}>
								Photography
							</button>
							<button
								type="button"
								style={{ background: News ? "#3A0DBB" : "", color: News ? "#fff" : "" }}
								onClick={() => setNews(!News)}>
								News
							</button>
							<button
								type="button"
								style={{ background: Pets ? "#3A0DBB" : "", color: Pets ? "#fff" : "" }}
								onClick={() => setPets(!Pets)}>
								Pets
							</button>
							<button
								type="button"
								style={{ background: RoadTrip ? "#3A0DBB" : "", color: RoadTrip ? "#fff" : "" }}
								onClick={() => setRoadTrip(!RoadTrip)}>
								RoadTrip
							</button>
						</div>
					</div>
				) : null}

				<div className={styles.recommendedDiv}>
					<div className={styles.HorizontalScroll}>
						{posts?.map((item, index) => (
							<img
								key={index}
								src={Array.isArray(item?.mediaUrl) 
									? (typeof item.mediaUrl[0] === 'string' ? item.mediaUrl[0] : item.mediaUrl[0]?.url) 
									: item?.mediaUrl}  
								alt="post"
								onClick={() => navigate(`/Post/${item?._id}`)}
								style={{ cursor: "pointer" }}
							/>
						))}
					</div>
				</div>
			</div>

			<div className={styles.ExploreImageMainContainer}>
				{isMobile ? null : <h3>Explore</h3>}
				<div className={styles.ExploreImageContainer}>
					{posts?.map((item, index) => (
						<img
							key={index}
							src={Array.isArray(item?.mediaUrl) 
								? (typeof item.mediaUrl[0] === 'string' ? item.mediaUrl[0] : item.mediaUrl[0]?.url) 
								: item?.mediaUrl}
							alt="post"
							onClick={() => navigate(`/Post/${item?._id}`)}
							style={{ cursor: "pointer" }}
						/>
					))}
				</div>
			</div>
		</>
	);
};

export default ExploreYourWorld;


